import { SearchResults } from "@/core/models/results";
import { Fragment, FunctionalComponent, h } from "@stencil/core";

interface SeatsBoxComponentProps {
  results: SearchResults;
}

export const SeatsBoxComponent: FunctionalComponent<SeatsBoxComponentProps> = ({
  results,
}) => (
  <Fragment>
    <div class="row no-spacing">
      <div class="col-8">
        <h2>AIRCRAFT DETAILS</h2>
      </div>
    </div>
    <div class="row no-spacing">
      <div class="col-8">
        <p class="aircraft-name">{results.aircraftTypeName}</p>
      </div>
    </div>
    <div class="row no-spacing align-bottom">
      <div class="col-sm-4">
        <h3 class="long-title">AIRCRAFT REGISTRATION</h3>
      </div>
      <div class="col-sm-4">
        <h3 class="long-title">
          FLIGHTS ON THIS ROUTE OVER THE LAST 12 MONTHS
        </h3>
      </div>
    </div>
    <div class="row narrow">
      <div class="col-sm-4">
        <p>{results.aircraftRegistration}</p>
      </div>
      <div class="col-sm-4">
        <p>{results.flightsOver12Months}</p>
      </div>
    </div>
    <div class="airplane row">
      <div class="col-sm-4">
        <p class="seats__title">SEAT CONFIGURATION</p>
        <div class="seats-column left">
          {results.seatClasses.map((seatClass) => (
            <div key={seatClass.name}>
              <p>{seatClass.name}</p>
              <p>{seatClass.seats}</p>
            </div>
          ))}
        </div>
      </div>
      <div class="col-sm-4">
        <p class="seats__title">CO2 (KG) PER AVAILABLE SEAT</p>
        <div class="seats-column right">
          {results.seatClasses.map((seatClass) => (
            <div key={seatClass.name}>
              <p>{seatClass.name}</p>
              <p>
                {seatClass.emissionsPerSeat?.toLocaleString(
                  window.navigator.language,
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  },
                )}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </Fragment>
);
